/**
 * Greetings.js
 * 
 * Purpose: This file serves as an anchor for the Gulp custom JavaScript build process.
 * It ensures the custom build pipeline has at least one file to process and validates
 * that the build system is working correctly.
 * 
 * This module outputs a greeting message to the console when loaded.
 */

(function() {
	'use strict';
	
	// ASCII art for "TOPTECH"
	var asciiArt = [
		'Greetings from,',
		' _____ ___  ____ _____ _____ ____ _   _ ',
		'|_   _/ _ \\|  _ \\_   _| ____/ ___| | | |',
		'  | | || ||| |_) || | |  _|| |   | |_| |',
		'  | | ||_|||  __/ | | | |__| |___|  _  |',
		'  |_| \\___/|_|    |_| |_____\\____|_| |_|',
		'',
		''
	].join('\n');
	
	// Output greeting to console
	console.log(asciiArt);
	
	// Optional: Export as module if using module system
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = {
			greet: function() {
				console.log(asciiArt);
			}
		};
	}
	
})();
